<template>
  <div class="container">
    <loading :active.sync="isLoading" 
        :can-cancel="false" 
		:is-full-page="true"></loading>
    <div class="row mt-5 pt-5 justify-content-center align-items-center">
      <div class="col-2">
        <div class="payment-logo">
          <a href="/">
            <img src="@/assets/amej-pay.png" alt="Amejpay" />
          </a>
        </div>
      </div>
      <div class="col-4">
        <h1 v-if="merchant_payment_details.merchant_account_detail">{{merchant_payment_details.merchant_account_detail.company_name}}</h1>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-7">
        <b-card>
          <div class="row text-center">
            <div class="col-12">
              <h2>Login Form</h2>
            </div>
          </div>
          <form
            class="payment-login-form"
            @submit.prevent="login"
            action
            method="post"
          >
            <div class="row">
              <div class="col-12 my-3">
                <input type="text" name="" v-model="username" required />
                <label
                  alt="Login User Name"
                  placeholder="Login User Name"
                ></label>
              </div>
            </div>
            <div class="row">
              <div class="col-12 my-2">
                <input
                  type="password"
                  v-model="password"
                  name="password"
                  required
                  class="w-100"
                />
                <label
                  alt="Login Password"
                  placeholder="Login Password"
                ></label>
              </div>
            </div>
            <div class="row justify-content-center pt-3">
              <div class="col-6">
                <router-link :to="{ name: 'merchant-payment' }">
                  <b-button variant="amej-button"> Back </b-button>
                </router-link>
              </div>
              <div class="col-6">
                <b-button @click="merchantLogin" type="submit" variant="amej-button">
                  Login
                </b-button>
              </div>
            </div>
          </form>
          <div class="row justify-content-center pt-5">
            <div class="col-2">
              <div class="payment-logo">
                <a href="/">
                  <img src="@/assets/amej-pay.png" alt="Amejpay" />
                </a>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <b-modal
      ref="loader_modal"
      id="loader_modal"
      class="loader_modal"
      size="sm"
      text-center
      headerClass="border-bottom-0"
      centered
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <div class="text-center p-4">
        <b-spinner variant="light" label="Text Centered"></b-spinner>
      </div>
    </b-modal>

    <b-toast
      id="error"
      variant="warning"
      solid
      append-toast
      toaster="b-toaster-bottom-full"
    >
      <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
        <strong class="mr-auto">Required error !!</strong>
      </div>
      <div v-if="errors.username">
        <p>{{ errors.username }}</p>
      </div>
      <div v-if="errors.password">
        <p>{{ errors.password }}</p>
      </div>
      <div v-if="errors.auth">
        <p>{{ errors.auth }}</p>
      </div>
    </b-toast>
    <Footer></Footer>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Footer from "../../reuseable_components/Footer";

const axios = require("axios");
export default {
  components: {
    Footer,
    Loading,
  },
  name: "",
  data() {
    return {
      isLoading: false,
      username: "",
      password: "",
      text: "Login Form",
      available: false,
      show: false,
      errors: { auth: [] },
      disabledLogin: true,
      submitted: false,
      transactionid: this.$route.params.transactionid
    };
  },
  created() {
    this.getMerchantPaymentDetailByTransactionId(this.transactionid);

    // var token = window.localStorage.getItem("token");
    // if (token != undefined && token != "") {
    //   this.$router.replace({
    //       name: "payment-confirm",
    //       params: {transactionid: this.transactionid}
    //     });
    // }
  },
  computed: {
    ...mapState(["token", "successmessage", "errormessage", "message", "merchant_payment_details"]),
  },
  mounted()  {
    if(this.transactionid == ""){
      // Guard: merchant_payment_details may not be loaded yet (initializes as [])
      var detail = this.merchant_payment_details && this.merchant_payment_details.merchant_payment_detail;
      if (detail && detail.failure_url) {
        var reloadUrl = detail.failure_url+"?status=fail&transaction_key="+detail.transaction_key;
        window.open(reloadUrl, "_self");
      }
    }
  },
  methods: {
    ...mapMutations(["setToken"]),
    ...mapActions(["getMerchantPaymentDetailByTransactionId"]),
    merchantLogin(e) {
      e.preventDefault();
      this.errors = [];
      if (this.username == "" || this.username == null) {
        this.errors["username"] = "Username is required";
        this.$bvToast.show("error");
      } else if (this.password == "" || this.password == null) {
        this.errors["password"] = "Password is required";
        this.$bvToast.show("error");
      } else {
        this.isLoading = true
        var formData = {
          email: this.$data.username,
          password: this.$data.password,
        };

        axios.post("checkuser", {
          email: this.$data.username,
        })
        .then((response) => {
          if (response.status == 200 && response.data.status == "true") {

            axios.post("token/obtain", formData)
            .then((responsenew) => {
              this.isLoading = false

              window.localStorage.setItem("token", responsenew.data.access);
              this.setToken(responsenew.data.access);
              axios.defaults.headers.common["authorization"] =
                  "Bearer " + responsenew.data.access;
              
              this.$router.replace({
                name: "payment-confirm",
                params: {transactionid: this.transactionid}
              });

            })
            .catch((error) => {
              this.isLoading = false
              if (error.response) {
                this.errors["auth"] = "Invalid Login Credentials.";
                this.$bvToast.show("error");
              }
              this.errored = true;
            });

          }
        })
        .catch((error) => {
          this.isLoading = false
          if (error.response.status == 401) {
            this.errors["auth"] = ["Admin cannot login."];
            this.$bvToast.show("error");
          } else if (error.response.status == 400) {
            this.errors["auth"] = ["Invalid username/password."];
            this.$bvToast.show("error");
          }
          this.errored = true;
        });

      }
    },
    
  },
};
</script>
<style lang="scss" scoped>
@import "../../../css/style.scss";
</style>